import { useTranslation } from "react-i18next";
import Field from "../../../../components/Field";
import Switch from "../../../../components/Inputs/Switch";

function Filters() {
    const { t } = useTranslation();

    return (
        <Field
            name={["filters", "includeInactiveOrgLevels"]}
            className="mb-0"
        >
            {({ value, onChange }) => (
                <Switch
                    checked={!!value}
                    onChange={(e) => onChange(e.target.checked)}
                >
                    {t("show-inactive-org-levels-in-report-filters")}
                </Switch>
            )}
        </Field>
    );
}

export default Filters;
